import { dataActionTypes } from "src/action_types/data_action_types";

import { loadStates } from "src/constants/load_states";

const defaultState = {
  loadState: loadStates.loading,
  data: []
};

/**
 * Reducer for population tally by location data
 */
export function populationTalliesByLocationReducer(
  state = defaultState,
  action
) {
  switch (action.type) {
    case dataActionTypes.populatePopulationTalliesByLocation:
      return {
        data: action.payload,
        loadState: loadStates.loaded
      };
    case dataActionTypes.populationTallyByLocationLoading:
      return { ...state, loadState: loadStates.loading };

    case dataActionTypes.populationTallyByLocationLoadError:
      return { ...state, loadState: loadStates.error };

    default:
      return state;
  }
}
